import TutorialsSlider from './components/Sliders/TutorialsSlider'

document.addEventListener("DOMContentLoaded", async () => {
   await  new TutorialsSlider().init()
});